import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, ActivityIndicator } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { Accordion, AccordionItem } from '@dbk/ui-accordion'
import { H1 } from '@dbk/ui-text';
import { Tabs, Tab } from '@dbk/ui-tabs';
import ListView from '../../../../../../src/components/common/list-view';
import Text, { Small, Large } from '../../../../../../src/components/common/text';
import TableRow from '../../../../../../src/components/common/table-row';
import StickyHeaderTablet from './sticky-header-tablet';
import { PALETTE, PAGE } from '../../../constants';
import CalendarModal from '../../../../../../src/components/common/calendar-modal';
import DateSelectionBar from '../../../../../../src/components/common/date-selection-bar';
import { ChangeIndicatedCurrency, ChangeIndicatedAbbreviatedNumber } from '../../../../../../src/components/common/number';
import Pagination from '../../../../../../src/components/common/pagination';
import format from 'date-fns/format';
import getPaginatedItems from '../../../../../../src/utils/get-paginated-items';
import SimpleDate from '../../../../../../src/components/common/date';
import styles from '../../../../../../src/screens/reports/transaction-history/transaction-history.styles';
import StickyHeader from '../../../../../../src/screens/reports/transaction-history/sticky-header';


let languageCode = 'en';

class TransactionHistory extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      timeline: 0,
      currentYear: new Date().getFullYear(),
      lastYear: new Date().getFullYear() - 1,
      fromDate: 'date',
      toDate: 'date',
      pageOffset: 0,
      activeItems: '',
      currentTab: 0,
    };

    this.onSelectTime = this.onSelectTime.bind(this);
    this.props.getTransactionDetails();
    this.returnTabletTransactionList = this.returnTabletTransactionList.bind(this);
    this.setPageOffset = this.setPageOffset.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { trans } = this.props;
    // watch values
    if (this.props.trans) {
      if ((trans.startDate != prevProps.trans.startDate) || (trans.endDate != prevProps.trans.endDate)) {
        this.props.getTransactionDetails();
      }
    }
  }

  setPageOffset(newOffset) {
    this.setState({ pageOffset: newOffset });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  onSelectTime(options) {
    this.setState({ timeline: options });
    this.setState({ pageOffset: 0 });
    if (this.state.currentTab != options) {
      switch (options) {
        case 0:
          this.props.setRange7Days();
          this.setState({ currentTab: 0 });
          break;
        case 1:
          this.props.setRange30Days();
          this.setState({ currentTab: 1 });
          break;
        case 2:
          this.props.setRange3Months();
          this.setState({ currentTab: 2 });
          break;
        case 3:
          this.props.setRangeYTD();
          this.props.trans.calendar.open();
          this.setState({ currentTab: 3 });
          break;
      }
    }
  }

  _renderHeader(row) {
    return (
      <View>
        <TableRow>
          <TableRow.Column align="left" >
            <Text>
              <SimpleDate value={row.tradeDate} />
            </Text>
          </TableRow.Column>
          <TableRow.Column align="left">
            <Text>
              {row.tranTypeDesc}
            </Text>
          </TableRow.Column>
          <TableRow.Column align="right">
            <Text style={styles.currencyText}>{row.ccyTrade}</Text>
            <Text align='right' style={{ color: '#fff' }}>
              <ChangeIndicatedAbbreviatedNumber
                renderProps={{ size: 'normal' }}
                value={parseFloat(row.netAmtTradeCcy)}
                // maxDigits={7}
                renderExactAs="currency"
                onlyNegativeStyling
              />
            </Text>
          </TableRow.Column>
        </TableRow>
      </View>
    );
  }

  _renderContent(row) {
    const { i18n: { messages }, } = this.props;
    return (
      <View >
        <View >
          <TableRow >
            <TableRow.Column align="left">
              <Text>{messages['app.incomehistory.productContent']}</Text>
            </TableRow.Column>
            <TableRow.Column align="left">
              <Text>
                <SimpleDate value={row.valueDate} />
              </Text>
            </TableRow.Column>
          </TableRow>
          <TableRow>
            <TableRow.Column align="left">
              <Text>
                {messages['app.report.transactionHistory.quantity']}
              </Text>
            </TableRow.Column>
            <TableRow.Column align="right">
              <Text secondary>{row.qty.toLocaleString()}</Text>
            </TableRow.Column>
          </TableRow>
          <TableRow>
            <TableRow.Column align="left">
              <Text>
                {messages['app.report.transactionHistory.purchasePrice']}
              </Text>
            </TableRow.Column>
            <TableRow.Column align="right">
              <Text secondary>{row.price}</Text>
            </TableRow.Column>
          </TableRow>
        </View>
        <Text>{row.securityLongName}</Text>
      </View>
    );
  }

  handleChange = (activeItems) => {
    this.setState(
      {
        activeItems,
      },
      () => {
        if (this.props.rememberState && this.props.state.setExpandedItem) {
          const [rowId] = activeItems;
          if (rowId) {
            this.props.state.setExpandedItem(rowId);
          }
        }
      }
    );
  };

  renderRows(rows) {
    return rows.map((row, index) => {
      const isRowActive = this.state.activeItems.indexOf(index) !== -1;
      console.log('isRowActive', isRowActive)
      return (
        <AccordionItem
          itemKey={index}
          key={index}
          renderTitle={() => this._renderHeader(row, isRowActive)}
        >
          {this._renderContent(row)}
        </AccordionItem>
      )
    });
  }

  returnTabletTransactionList(asset, langCode) {
    const { tradeDate, tranTypeDesc, securityLongName, ccyTrade, valueDate, qty, netAmtTradeCcy } = asset;
    const locale = {
      en: 'en',
      de: 'de-DE'
    }
    return (
      <div className="row">
        <div className="columns small-2 medium-2 large-2">
          <Text ><SimpleDate value={tradeDate} /> </Text>
        </div>
        <div className="columns small-2 medium-2 large-2">
          <Text ><SimpleDate value={valueDate} /></Text>
        </div>
        <div className="columns small-2 medium-2 large-2">
          <Text >{tranTypeDesc}</Text>
        </div>
        <div className="columns small-3 medium-3 large-3">
          <Text >{securityLongName}</Text>
        </div>
        <div className="columns small-1 medium-1 large-1 text-align-right columnCustomWidth">
          <Text >{qty.toLocaleString(locale[langCode])}</Text>
        </div>
        <div className="columns small-2 medium-2 large-2 text-align-right columnCustomWidth">
          <Text >
            {netAmtTradeCcy === null ? "-" :
              <ChangeIndicatedCurrency
                value={parseFloat(netAmtTradeCcy)}
                renderProps={{ size: 'small' }}
                currency={ccyTrade}
                onlyNegativeStyling />}
          </Text>
        </div>
      </div>
    );
  }

  render() {
    let stickyHeader = <StickyHeader />;
    const { screen, i18n: { messages }, auth: { langCode } } = this.props;
    const { transactionHistoryList, isLoading, startDate, endDate } = this.props.trans;
    let transaction = [];
    let completeDate;

    if (this.props.auth.langCode && this.props.auth.langCode != null) {
      languageCode = this.props.auth.langCode.toLowerCase();
    }

    if (startDate == endDate) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.singleLanguage']} <SimpleDate month='long' value={format(startDate, 'DD MMMM YYYY')} /></div>;
    } else if (startDate != undefined && startDate.length != 0 && endDate != undefined && endDate.length != 0) {
      completeDate = <div> {messages['app.maturities.dateSelectionBar.currentlyShowing.multipleLanguage']} <SimpleDate month='long' value={format(startDate, 'DD MMMM YYYY')} /> {messages['app.common.to']} <SimpleDate month='long' value={format(endDate, 'DD MMMM YYYY')} /></div>;
    }

    if (transactionHistoryList != undefined && transactionHistoryList != null) {
      transaction = transactionHistoryList;
    }

    const { pageOffset } = this.state;
    const pageSize = PAGE.pageSize;
    const paginatedTransactions = getPaginatedItems(transaction, pageOffset, pageSize);

    {
      !screen.isSmall ? stickyHeader = <StickyHeaderTablet messages={messages} />
        : stickyHeader = <StickyHeader messages={messages} />
    }

    return (
      <div style={styles.container}>
        <H1 secondary>
          {messages['app.common.pageTitle.transactionHistory']}
        </H1>
        <div >
          <View>
            <Tabs
              stretch
              secondary
              handleSelectedIndex={this.onSelectTime}
              selectedIndex={this.state.timeline}
            >
              <Tab style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.incomehistory.7days']}/>
              <Tab style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.report.transactionHistory.30days']}/>
              <Tab style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.report.transactionHistory.3months']}/>
              <Tab style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => messages['app.maturities.overview.tabs.labels.custom']}/>
            </Tabs>
          </View>
          {/* </div> */}
          <div className="columns small-10 small-centered medium-12 medium-centered large-12 large-centered">
            <DateSelectionBar
              text={completeDate}
              isEditable={(this.state.timeline === 3)}
              onEditPress={() => this.props.trans.calendar.open()} />
            <CalendarModal
              numberOfPastMonth={3}
              calendarModal={this.props.trans.calendar}
              messages={messages}
              scrollOnce
              languageCode={languageCode}
            />
          </div>
          {stickyHeader}
          <View>
            {!screen.isSmall ?
              <View>
                {isLoading ?
                  <View style={styles.loadingIndicator}>
                    <ActivityIndicator
                      animating
                      color={PALETTE.primaryText}
                      size="large"
                    />
                  </View>
                  :
                  <span>
                    {paginatedTransactions.length > 0 ?
                      <ListView
                        rows={paginatedTransactions}
                        testID="trans"
                        renderRow={(trans) => (
                            <ListView.Row>
                              {this.returnTabletTransactionList(trans, languageCode)}
                            </ListView.Row>
                          )}
                      />
                      : <div className="text-center margin-top-20">
                        <Large> {messages['app.reports.noRecords']}</Large>
                      </div>
                    }
                  </span>
                }
              </View>
              :
              <span>
                {isLoading ?
                  <View style={styles.loadingIndicator}>
                    <ActivityIndicator
                      animating
                      color={PALETTE.primaryText}
                      size="large"
                    />
                  </View>
                  :
                  <View style={styles.root}>
                    <View style={{ marginLeft: 5, marginRight: 5 }}>
                      {paginatedTransactions.length > 0 ?
                        <Accordion
                          testID="list"
                          activeItems={this.state.activeItems}
                          onChange={this.handleChange}
                        >
                          {this.renderRows(paginatedTransactions)}
                        </Accordion>
                        : <Large style={styles.empty}> {messages['app.reports.noRecords']} </Large>
                      }
                    </View>
                  </View>
                }
              </span>
            }

            <Pagination
              pageOffset={pageOffset}
              pageSize={pageSize}
              totalRecords={transaction.length}
              setPageOffset={this.setPageOffset}
              style={{ marginVertical: 20 }} />

          </View>
        </div>
      </div>
    );
  }
}

TransactionHistory.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  trans: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getTransactionDetails: {
      $call: 'trans.getTransactionDetails'
    },
    trans: {
      calendar: {
        open: {
          $call: 'open'
        },
        ...CalendarModal.getFragment('calendarModal'),
      },
      startDate: true,
      endDate: true,
      dateDisplay: true,
      transactionHistoryList: true,
      isLoading: true,
    },
    getStatementPdf: {
      $call: 'trans.getPdf'
    },
    setRange7Days: {
      $call: 'trans.setRange7Days'
    },
    setRange30Days: {
      $call: 'trans.setRange30Days'
    },
    setRange3Months: {
      $call: 'trans.setRange3Months'
    },
    setRangeYTD: {
      $call: 'trans.setRangeYTD'
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      },
    },
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    auth: {
      langCode: true,
    },
  },
}, ({ app, ...queries }) => ({
  ...queries,
  deviceInfo: app.global.deviceInfo,
}))(TransactionHistory);

export { TransactionHistory };
